// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "html2canvas2jspdf.umd." + chunkId + ".js";
};